module.exports = __webpack_public_path__ + "img/mm.e8f2d077.svg";